import Modal, { ModalProps } from './Modal';
import { useGetBudgetReference, useGetBudgetSlp } from '../../hooks/budgets';

import { ReactComponent as BarChartIcon } from '../../assets/chart-bar.svg';
import Button from '../common/Button';
import { DateTime } from 'luxon';
import EmptyState from '../common/EmptyState';
import ForecastLineChart from '../overview/widgets/forecast/ForecastLineChart';
import { Fragment } from 'react';
import MeterForecastInformation from '../overview/widgets/forecast/MeterForecastInformation';
import { SdpResponse } from '../../models/SdpResponse';
import Skeleton from 'react-loading-skeleton';
import { useTranslation } from 'react-i18next';

export interface ModalForecastInformationProps extends ModalProps {
  sdp?: SdpResponse | null;
}
export default function ModalForecastInformation({
  isOpen,
  sdp,
  onClickAction,
  onClose,
}: ModalForecastInformationProps) {
  const { t } = useTranslation();
  const {
    isFetching: isFetchingBudgetReference,
    isError: IsErrorBudgetReference,
    data: budgetReference,
  } = useGetBudgetReference(sdp?.id);

  const {
    isFetching: isFetchingBudgetSlp,
    isError: IsErrorBudgetSlp,
    data: budgetSlp,
  } = useGetBudgetSlp(sdp?.id, sdp?.tariffChoice);
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      actions={
        <Fragment>
          <Button className="btn btn--secondary" onClick={onClickAction}>
            {t('common.close')}
          </Button>
        </Fragment>
      }
    >
      <Fragment>
        {isFetchingBudgetReference ||
        IsErrorBudgetReference ||
        isFetchingBudgetSlp ||
        IsErrorBudgetSlp ? (
          <div className="text-center">
            <Skeleton count={1} height={16} width="40%" className="mb-2" />
            <Skeleton count={1} height={16} width="80%" className="mb-4" />
            <Skeleton count={1} height={80} width="80%" className="mb-2" />
            <Skeleton count={1} height={16} width="70%" className="mb-4" />
            <Skeleton count={1} height={16} width="50%" className="mb-6" />
          </div>
        ) : budgetSlp?.status !== 204 ? (
          <Fragment>
            <MeterForecastInformation hasCaption={false} budgetReference={budgetReference?.data} />
            <ForecastLineChart
              data={budgetSlp?.data.map((item) => ({
                x: DateTime.fromISO(item.time)
                  .minus({
                    hours: 1,
                  })
                  .toMillis(),
                y: item.value,
              }))}
            />
          </Fragment>
        ) : (
          <EmptyState message={t('common.no.data')} icon={<BarChartIcon />} />
        )}
      </Fragment>
    </Modal>
  );
}
